import React from 'react';
import { Button } from '@mui/material';
import './App.css';

function App() {
  const exhibitTitle = "TutuTango";
  // const exhibitDate = "August 15 - September 15, 2024";
  // const exhibitLocation = "";
  // const introductionText = "";

  return (
    <div className="App">
      <main className="homepage">
        <div className="hero">
          <div className="text-container">
            <h1 className="title">{exhibitTitle}</h1>
            <div className="buttons">
              <div className="button-container">
                <Button 
                  component="a"
                  href="https://vimeo.com/839799821/a6ea99977e"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  className="button"
                >
                  Movie
                </Button>
                <Button
                  component="a"
                  href="https://www.fmopa.org/tututango-photographic-ballet/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  className="button"
                >
                  Exhibit
                </Button>
                <Button 
                  component="a"
                  href="https://vimeo.com/985858446/6cc6182f8a"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  className="button"
                >
                  Footage
                </Button>
              </div>
              <div className="button-container names">
                <Button
                  component="a"
                  href="https://www.michaelsheehanphotos.com/home"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  className="button name"
                >
                  Michael Sheehan
                </Button>
                <Button
                  component="a"
                  href="https://elfringphotography.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  className="button name"
                >
                  Dorothee Elfring
                </Button>
              </div>
            </div>
            {/* <p className="description">{introductionText}</p> */}
          </div>
        </div>
      </main>

    </div>
  );
}

export default App;
